<template>
    <div class="index">
        <div class="indexNew">
            <el-row :gutter="24" class="top_box">
                <el-col :md="col_1" v-if="col_1>0">
                    <div class="index_top">
                        <MyBox :title="'会员待发货订单信息'" @refresh="refreshFn('orderList')">
                            <OrderList ref="orderList"></OrderList>
                        </MyBox>
                    </div>
                </el-col>
                <el-col :md="col_2" v-if="col_2>0">
                    <div class="index_top">
                        <MyBox :title="'凤享荟兑付信息'" @refresh="refreshFn('FxhList')">
                            <FxhList ref="FxhList">
                            </FxhList>
                        </MyBox>
                    </div>
                </el-col>
                <el-col :md="col_3">
                    <div class="index_top">
                        <MyBox :title="'消息公告'" @refresh="refreshFn('messageTable')">
                            <MessageTable ref="messageTable"></MessageTable>
                        </MyBox>
                    </div>
                </el-col>
                <el-col :md="col_4">
                    <div class="index_top">
                        <MyBox :title="'待处理'" @refresh="refreshFn('todoList')">
                            <TodoList ref="todoList"></TodoList>
                        </MyBox>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :md="6">
                    <div class="index_bottom">
                        <MyBox :title="'我的申请'" class="myApp borderStyle" @refresh="refreshFn('myApply')">
                            <MyApply ref="myApply"></MyApply>
                        </MyBox>
                    </div>
                </el-col>
                <el-col :md="6">
                    <div class="index_bottom">
                        <MyBox :title="'企业用户待处理数据'" class="borderStyle" @refresh="refreshFn('user')">
                            <User ref="user"></User>
                        </MyBox>
                    </div>
                </el-col>
                <el-col :md="6">
                    <div class="index_bottom">
                        <MyBox :title="'被驳回'" class="borderStyle" @refresh="refreshFn('rejectList')">
                            <RejectList ref="rejectList"></RejectList>
                        </MyBox>
                    </div>
                </el-col>
                <el-col :md="6">
                    <div class="index_bottom">
                        <MyBox :title="'即将超期核销数据'" class="borderStyle" @refresh="refreshFn('cqhxList')">
                            <cqhxList ref="cqhxList"></cqhxList>
                        </MyBox>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog title="即将超期核销数据" :visible.sync="dialogTableVisible" :append-to-body="true"
            :modal-append-to-body="true">
            <el-table :data="gridData" border header-cell-style="background-color: #e8e8e8;color:#606266">
                <el-table-column property="actName" label="活动名称"></el-table-column>
                <el-table-column property="actCode" label="活动编码">
                    <template slot-scope="scope">
                        <span style="color: #c34231; cursor: pointer;"
                            @click="handleActCodeClick(scope.row)">
                            {{ scope.row.actCode }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column property="responseName" label="负责人"></el-table-column>
                <el-table-column property="createName" label="创建人"></el-table-column>
                <el-table-column property="noAuditAmount" label="待核销金额"></el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>

</template>
<script>

import Storage from '@/found/utils/storage';
import request from '@/found/utils/request';
import MyBox from './components/my_box.vue'; // 外层盒子
import MessageTable from './components/my_dos/message_list.vue'; // 消息公告
import OrderList from './components/my_dos/order_list.vue'; // 订单消息
import FxhList from './components/my_dos/fxh_list.vue'; // 订单消息
import TodoList from './components/my_dos/todo_list.vue'; // 待处理
import MyApply from './components/my_dos/my_apply.vue'; // 我的申请
import RejectList from './components/my_dos/reject_list.vue';
import cqhxList from './components/my_dos/cqhx_list.vue'; // 超期核销数据
import User from './components/my_dos/user.vue'; // 企业用户待处理数据
// 被驳回
export default {
  components: {
    MyBox,
    MessageTable,
    TodoList,
    MyApply,
    RejectList,
    OrderList,
    FxhList,
    cqhxList,
    User,
  },
  data() {
    return {
      imgList: [
        require('../../assets/img/BI.png'),
        require('../../assets/img/OA.png'),
        require('../../assets/img/CRM.png'),
        require('../../assets/img/SAP.png'),
      ],
      value: '',
      options: [],
      col_1: 0,
      col_2: 0,
      col_3: 12,
      col_4: 12,
      dialogTableVisible: false,
      gridData: [],
      // 添加分页相关数据
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    const userInfo = Storage.l.get('userInfo') ? JSON.parse(Storage.l.get('userInfo')) : {};
    console.log(userInfo);
    this.getNum();
    this.getMoney();
  },
  methods: {
    // 选中某天
    clickDay() {},
    // 左右点击切换月份
    changeDate() {},
    // 刷新列表
    refreshFn(demoName) {
      const $demo = this.$refs[`${demoName}`];

      if (demoName === 'mydos') {
        $demo.$refs[`tabs${$demo.currentTab}`].getList();
      } else {
        $demo.getList();
      }
    },
    getNum() {
      request.post('/mdm/orderPermission/getOrderPermissionByPositionCode', {}).then((res) => {
        if (res.success) {
          this.col_1 = res.result.col_1;
          this.col_2 = res.result.col_2;
          this.col_3 = (24 - res.result.col_1 - res.result.col_2) / 2;
          this.col_4 = (24 - res.result.col_1 - res.result.col_2) / 2;
        }
      });
    },
    getMoney() {
      // 修改请求以支持分页参数
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      request.post('/tpm/tpmActExpireController/findExpireAct', params).then((res) => {
        console.log(res);
        if (res.success && res.result.data.length > 0) {
          this.dialogTableVisible = true;
          this.gridData = res.result.data || [];
          this.total = res.result.count;
        }
      });
    },
    handleActCodeClick() {
      this.dialogTableVisible = false;
      this.$router.push({ path: '/tpm_center/pay_center/write_off' });
    },
    // 添加分页事件处理方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMoney();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMoney();
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px !important;
  right: 0px !important;
  background-color: #f3f3f3;
}
.indexNew {
  height: 100%;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
}
/deep/.content-container {
  background-color: #f3f3f3 !important;
}
/deep/.el-main .content {
  background-color: #f3f3f3 !important;
}
/deep/.box[data-v-34871b32] {
  background-color: #f3f3f3;
}
.top_box {
  display: flex;
  flex: 1;
  margin: 0 0 10px 0;
}
.borderStyle {
  border: 1px solid #e1e1e1;
}
.index_top {
  background-color: #fff;
  border: 1px solid #e1e1e1;
  height: 100%;
  min-height: 260px;
}
.index_bottom {
  min-height: 470px;
  height: calc(60vh - 20px);
}
.myApp {
  margin-bottom: 10px;
}
.index_right_bottom .box:first-child {
  height: 24%;
}
.index_right_bottom .box:last-child {
  height: calc(76% - 10px);
}
.img_item {
  width: 42px;
  height: 42px;
  margin: 12px;
}
.flex-justify-end {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.el-col {
  padding-right: 0 !important;
}
.content-container {
  background-color: #f3f3f3 !important;
}
.el-main .content {
  background-color: #f3f3f3 !important;
}
</style>
<style lang="less">
.el-main .content {
  position: relative;
}
.wh_content_all {
  background-color: #fff !important;
}
.wh_top_changge li,
.wh_content_item {
  color: #333 !important;
}
.wh_content_item .wh_isToday {
  color: #409eff !important;
  background-color: rgba(64, 158, 255, 0.2) !important;
}
.wh_item_date:hover {
  background-color: rgba(64, 158, 255, 0.2) !important;
  border-radius: 100px;
}
.wh_content {
  justify-content: center !important;
}
.wh_top_changge {
  display: none !important;
}
.wh_content_item .wh_chose_day {
  background-color: rgba(64, 158, 255, 0.2) !important;
}
.pagination-container {
  text-align: right;
  margin-top: 20px;
}
</style>
